<template>
  <div>
    <activity-status-updated :channel="publicChannel" />
    <connection-opened :channel="publicChannel" />
    <connection-closed :channel="publicChannel" />
    <connection-busy :channel="publicChannel" />
    <connection-no-answer :channel="publicChannel" />
    <connection-failed :channel="publicChannel" />
    <message-created :channel="privateChannel" />
    <recording-started :channel="publicChannel" />
    <recording-paused :channel="publicChannel" />
    <recording-resumed :channel="publicChannel" />
    <recording-stopped :channel="publicChannel" />

    <slot v-if="subscribed"></slot>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'
  import ActivityStatusUpdated from './activity-status-updated'
  import ConnectionOpened from './connection-opened'
  import ConnectionClosed from './connection-closed'
  import ConnectionBusy from './connection-busy'
  import ConnectionNoAnswer from './connection-no-answer'
  import ConnectionFailed from './connection-failed'
  import MessageCreated from '@/components/shared/message-created/message-created'
  import RecordingStarted from './recording-started'
  import RecordingPaused from './recording-paused'
  import RecordingResumed from './recording-resumed'
  import RecordingStopped from './recording-stopped'

  const { mapState } = createNamespacedHelpers('conference')
  let publicChannelName
  let privateChannelName

  export default {
    components: {
      ActivityStatusUpdated,
      ConnectionOpened,
      ConnectionClosed,
      ConnectionBusy,
      ConnectionNoAnswer,
      ConnectionFailed,
      MessageCreated,
      RecordingStarted,
      RecordingPaused,
      RecordingResumed,
      RecordingStopped
    },
    data () {
      return {
        publicChannel: null,
        publicChannelSubscribed: false,
        privateChannel: null,
        privateChannelSubscribed: false
      }
    },
    computed: {
      ...mapState([
        'activity'
      ]),
      subscribed () {
        return this.publicChannelSubscribed && this.privateChannelSubscribed
      }
    },
    created () {
      this.registerPusher()
    },
    beforeDestroy () {
      this.$pusher.unsubscribe(publicChannelName)
      this.$pusher.unsubscribe(privateChannelName)
    },
    methods: {
      registerPusher () {
        publicChannelName = `activity.${this.activity.id}`
        privateChannelName = `private-activity.${this.activity.id}`

        this.publicChannel = this.$pusher.subscribe(publicChannelName)
        this.privateChannel = this.$pusher.subscribe(privateChannelName)

        this.publicChannel.bind('pusher:subscription_succeeded', () => (this.publicChannelSubscribed = true))
        this.privateChannel.bind('pusher:subscription_succeeded', () => (this.privateChannelSubscribed = true))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// with-pusher-subscription.vue?2113c121